import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApisRequestService } from './apis-request.service';

@Injectable()
export class ApisService {
  constructor(private request: ApisRequestService) { }

  checkPepStatus(egn: string, name?: string): Observable<boolean> {
    return this.request.post(['apis', 'peps', 'check', 'status'], {
      body: { ident: egn, searchText: name }
    });
  }

  getPepReport(civilId: string): Observable<any> {
    return this.request.get(['apis', 'peps', 'report', civilId]);
  }

  searchRegdata(egn: string, phoneNumber: string, pageNum: number = 1, pageSize: number = 100): Observable<any> {
    return this.request.post(['apis', 'regdata', 'search', 'egn'], {
      body: { egn, phoneNumber, pageNum, pageSize }
    });
  }
}
